import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styles from './YayinlarListe.module.css';
import PageHeader from '../../components/PageHeader/PageHeader';
import Table from '../../components/Table/Table';
import FilterCard from '../../components/FilterCard/FilterCard';
import { FaFileExcel } from 'react-icons/fa';
import { BsEye, BsInboxFill } from 'react-icons/bs';
import Select from '../../components/Select/Select';

const NoDataFound = () => (
  <div className="no-data-found">
    <BsInboxFill className="no-data-icon" />
    <h3 className="no-data-title">Gösterilecek Veri Bulunamadı</h3>
    <p className="no-data-text">
      Arama kriterlerinize uygun veri bulunmamaktadır. Lütfen filtrelerinizi değiştirerek tekrar deneyin.
    </p>
  </div>
);

const YayinlarListe = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [selectedYear, setSelectedYear] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState([]);

  const yearOptions = [
    { value: 'all', label: 'Tüm Yıllar' },
    { value: '2024', label: '2024' },
    { value: '2023', label: '2023' },
    { value: '2022', label: '2022' }
  ];

  const periodOptions = [
    { value: 'all', label: 'Tüm Dönemler' },
    { value: '1', label: '1. Dönem' },
    { value: '2', label: '2. Dönem' }
  ];

  const titleOptions = [
    { value: 'all', label: 'Tüm Ünvanlar' },
    { value: 'prof', label: 'Prof. Dr.' },
    { value: 'doc', label: 'Doç. Dr.' },
    { value: 'dr', label: 'Dr. Öğr. Üyesi' }
  ];

  const handleYearChange = (selectedOptions) => {
    setSelectedYear(selectedOptions);
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedYear([{ value: 'all', label: 'Tüm Yıllar' }]);
    }
  };

  const handlePeriodChange = (selectedOptions) => {
    setSelectedPeriod(selectedOptions);
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedPeriod([{ value: 'all', label: 'Tüm Dönemler' }]);
    }
  };

  const handleTitleChange = (selectedOptions) => {
    setSelectedTitle(selectedOptions);
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedTitle([{ value: 'all', label: 'Tüm Ünvanlar' }]);
    }
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const handleExcelExport = () => {
  };

  const getFilteredAndSortedData = (data) => {
    let filteredData = data.filter(item => {
      const matchesSearch = Object.values(item).some(val => 
        val.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );

      const matchesTitle = selectedTitle.length === 0 || 
        selectedTitle.some(t => t.value === 'all') ||
        selectedTitle.some(t => t.value === item.unvan.toLowerCase().replace(/\s+/g, ''));

      const matchesYear = selectedYear.length === 0 ||
        selectedYear.some(y => y.value === 'all');

      const matchesPeriod = selectedPeriod.length === 0 ||
        selectedPeriod.some(p => p.value === 'all');

      return matchesSearch && matchesTitle && matchesYear && matchesPeriod;
    });

    if (sortConfig.key) {
      filteredData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    return filteredData;
  };

  const columns = [
    { key: 'unvan', title: 'Ünvan', sortable: true },
    { key: 'adSoyad', title: 'Ad-Soyad', sortable: true },
    { key: 'fakulte', title: 'Fakülte', sortable: true },
    { key: 'bolum', title: 'Bölüm', sortable: true },
    { key: 'yayinSayisi', title: 'Yayın Sayısı', sortable: true },
    { key: 'atifSayisi', title: 'Atıf Sayısı', sortable: true },
    { 
      key: 'islemler', 
      title: 'İşlemler',
      render: (_, row) => {
        if (!row) return null;
        return (
          <div className="d-flex gap-2 justify-content-center">
            <button 
              className={`${styles.actionButton} ${styles.viewButton}`}
              onClick={() => navigate(`/akademisyen/${row.id}`)}
              aria-label={`${row.adSoyad} detaylarını görüntüle`}
            >
              <BsEye className={styles.buttonIcon} />
              <span className={styles.buttonText}>Detay</span>
            </button>
          </div>
        );
      }
    }
  ];

  const mockData = [
    {
      id: 1,
      unvan: 'Prof. Dr.',
      adSoyad: 'Lorem Ipsum',
      fakulte: 'Mühendislik Fakültesi',
      bolum: 'Bilgisayar Mühendisliği',
      yayinSayisi: 15,
      atifSayisi: 150
    },
    {
      id: 2,
      unvan: 'Doç. Dr.',
      adSoyad: 'Aqua Qularis',
      fakulte: 'Mühendislik Fakültesi',
      bolum: 'Elektrik Mühendisliği',
      yayinSayisi: 10,
      atifSayisi: 120
    }
  ];

  const renderTableContent = () => {
    const filteredData = getFilteredAndSortedData(mockData);
    
    if (filteredData.length === 0) {
      return <NoDataFound />;
    }

    return (
      <Table 
        columns={columns}
        data={filteredData}
        onSort={handleSort}
        sortConfig={sortConfig}
        sortable
      />
    );
  };

  return (
    <div className="wrapper">
      <PageHeader 
        title="Yayınlar-Liste"
        description="Akademik yayın performansı ve istatistikler"
        breadcrumbs={[
          { text: 'Ana Sayfa', href: '/' },
          { text: 'Yayınlar', href: '/yayinlar' },
          { text: 'Yayınlar-Liste' }
        ]}
      />

      <FilterCard title="" className={styles['filter-card']}>
        <FilterCard.Row className={styles['filter-row']}>
          <FilterCard.Col className={`justify-content-end d-flex`}>
            <FilterCard.Button 
              className={`${styles.actionButton} ${styles.exportButton}`}
              variant="success"
              icon={<FaFileExcel className={styles.buttonIcon} />}
              onClick={handleExcelExport}
            >
              Excel'e Aktar
            </FilterCard.Button>
          </FilterCard.Col>
        </FilterCard.Row>
        <FilterCard.Row className={styles['filter-row']}>
          <FilterCard.Col className={styles['filter-col']}>
            <FilterCard.FormGroup label="Yıl" className={styles['form-group']}>
              <Select
                options={yearOptions}
                value={selectedYear}
                onChange={handleYearChange}
                placeholder="Yıl seçin..."
              />
            </FilterCard.FormGroup>
          </FilterCard.Col>
          <FilterCard.Col className={styles['filter-col']}>
            <FilterCard.FormGroup label="Dönem" className={styles['form-group']}>
              <Select
                options={periodOptions}
                value={selectedPeriod}
                onChange={handlePeriodChange}
                placeholder="Dönem seçin..."
              />
            </FilterCard.FormGroup>
          </FilterCard.Col>
          <FilterCard.Col className={styles['filter-col']}>
            <FilterCard.FormGroup label="Ünvan" className={styles['form-group']}>
              <Select
                options={titleOptions}
                value={selectedTitle}
                onChange={handleTitleChange}
                placeholder="Ünvan seçin..."
              />
            </FilterCard.FormGroup>
          </FilterCard.Col>
        </FilterCard.Row>

        <FilterCard.Row className={`${styles['filter-row']} text-end`}>
          <FilterCard.Col className={`${styles['filter-col']} ${styles['search-col']}`}>
            <FilterCard.SearchInput
              className={styles['search-input']}
              placeholder="Ad, soyad veya bölüm ara..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </FilterCard.Col>
        </FilterCard.Row>
      </FilterCard>

      <div className="card border-0 shadow-sm publications-list">
        <div className="card-body">
          {renderTableContent()}
        </div>
      </div>
    </div>
  );
};

export default YayinlarListe; 